package com.rajen.angrejidictionary.domain.model

data class Word(
    val englishWord: String,
    val partOfSpeech: String,
    val pronunciationGujarati: String,
    val meanings: List<String>,
    val wordForms: List<WordForm> = emptyList(),
    val similarWords: List<RelatedWord> = emptyList(),
    val oppositeWords: List<RelatedWord> = emptyList(),
    val usage: WordUsage? = null,
    val phrasals: List<PhrasalVerb> = emptyList(),
    val tenses: List<Tense> = emptyList(),
    val tenseRule: String = "",
    // Unique views, only returned by the word detail endpoint. null = hide the label.
    val viewCount: Long? = null
)

data class WordForm(
    val word: String,
    val partOfSpeech: String,
    val pronunciationGujarati: String,
    val meanings: List<String>,
    val exampleSentence: String,
    val examplePronunciationGujarati: String,
    val exampleMeaningGujarati: String
)

data class RelatedWord(
    val word: String,
    val partOfSpeech: String,
    val pronunciationGujarati: String,
    val meanings: List<String>
)

data class WordUsage(
    val whenGujarati: String,
    val whereGujarati: String,
    val whyGujarati: String
)

data class PhrasalVerb(
    val form: String,
    val pronunciationGujarati: String,
    val meanings: List<String>,
    val examples: List<PhrasalExample>
)

data class PhrasalExample(
    val sentence: String,
    val pronunciationGujarati: String,
    val meaningGujarati: String
)

data class Tense(
    val type: String,
    val word: String
)